var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_vm._v(" 인터뷰상세페이지 "), _c('v-card-title', [_vm._v(_vm._s(_vm.interview.subject))]), _c('v-img', {
    attrs: {
      "src": _vm.interview.thumb
    }
  }), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.interview.content)
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }